import * as React from "react";
import {
    SAVE_METHOD_TOOLBAR,
    SAVE_CHANGES_STATE_KEY,
    ADD_METHOD_TOOLBAR,
    ADD_NEW_DRAFT_WORK_STATE_KEY,
    UNDO_METHOD_TOOLBAR,
    COPY_METHOD_TOOLBAR,
    COPY_DRAFT_WORK_STATE_KEY,
    UNDO_CHANGES_DRAFT_WORK_STATE_KEY,
    DRAFT_WORKS_MAINTENANCE_TOOLBAR, 
    ADD_NEW_WORK_STATE_KEY,
    COPY_WORK_STATE_KEY
} from "../../../Consts";
import IMembersPortalComponentDataItem from "../../../../redux/types/IMembersPortalComponentDataItem";
import { clearModalSearchResults} from "../../../../redux/reducers/MembersPortalReducer";
import { showYesNoPrompt, hideModal, showModal } from "../../../../redux/reducers/ModalReducer";
import { ITabReduxItem } from "../../../../redux/types/ITabReduxItem";
import { IDataActionToolbar } from "../../../../repertoire/types/IDataActionToolbar";
import { ILookupDictionary } from "../../../../lookup/types/ILookupDictionary";
import ToolbarComponent from "../../../components/toolBar/ToolBarComponent";
import { IWorkState } from "../../../../redux/types/IWorkState";
import { DataSource } from "../../../../repertoire/types/DataSource";
import { MembersPortalRoles } from "../../../../redux/types/MembersPortalRoles";
import { MembersPortalService } from "../../../../redux/services/MembersPortalService";

export interface IDraftWorksMaintenanceToolbarProps {
    changesMade: boolean;
    showYesNoPrompt: typeof showYesNoPrompt;
    hideModal: typeof hideModal;
    resetMessageBanner: () => void;
    scroll: number;
    toolbarWidth: number;
    toolbarData: IMembersPortalComponentDataItem;
    saveResultData?: IMembersPortalComponentDataItem;
    work: IWorkState;
    dataSource: DataSource;
    activeTab: number;
    tabs: ITabReduxItem[];
    saveChanges: () => void;
    isReadonly: boolean;
    undoDraftWorksChanges: () => void;
    addNewDraftWorks: () => void;
    isNew?: boolean;
    currentUser?: string;
    lookupValues: ILookupDictionary;
    showModal: typeof showModal;
    copyDraftWork: (actionList: IDataActionToolbar[], userName: string, lookups: ILookupDictionary) => void;
    customer?: string;
}

export interface IDraftWorksMaintenanceToolbarState {
    dataAction: IDataActionToolbar[];
}

export type DraftWorksMaintenanceToolbarKeys = keyof IDraftWorksMaintenanceToolbarProps;

class DraftWorksMaintenanceToolbar extends React.Component<
    IDraftWorksMaintenanceToolbarProps,
    IDraftWorksMaintenanceToolbarState
> {
    actionData;

    constructor(props) {
        super(props);
        this.state = {
            dataAction: this.getDataAction()
        };
    }

    saveChangesAction = () => {
        const { saveChanges } = this.props;
        saveChanges();
    }

    copyDraftWork = () => {
        
        const { tabs, activeTab, copyDraftWork,currentUser, lookupValues } = this.props;  
        const actionList = tabs[activeTab].dataActionToolbar;        
        copyDraftWork(actionList,currentUser,lookupValues);
    }
    resetMessageBanner() {
        const { resetMessageBanner } = this.props;
        resetMessageBanner();
    }
    
    getDataAction() {
        const {
            toolbarData: { fields },
            undoDraftWorksChanges,
            addNewDraftWorks,
            isNew
        } = this.props;
        const actionList: IDataActionToolbar[] = [];

        const copyDraftWorksAction: IDataActionToolbar = {
            action: this.copyDraftWork,
            component: DRAFT_WORKS_MAINTENANCE_TOOLBAR,
            method: COPY_METHOD_TOOLBAR,
            name: fields.find(d => d.name === COPY_DRAFT_WORK_STATE_KEY).data,
            icon: 'icon ms-Icon ms-Icon--Copy'
        };
        actionList.push(copyDraftWorksAction);

        

        const save: IDataActionToolbar = {
            action: this.saveChangesAction.bind(this),
            component: DRAFT_WORKS_MAINTENANCE_TOOLBAR,
            method: SAVE_METHOD_TOOLBAR,
            name: fields.find(save => save.name === SAVE_CHANGES_STATE_KEY).data,
            icon: ''
        };
        actionList.push(save);


        const undo: IDataActionToolbar = {
             action: undoDraftWorksChanges,
             component: DRAFT_WORKS_MAINTENANCE_TOOLBAR,
             method: UNDO_METHOD_TOOLBAR,
             name: fields.find(undo => undo.name === UNDO_CHANGES_DRAFT_WORK_STATE_KEY).data,
             icon: 'icon ms-Icon ms-Icon--Undo'
        };
        actionList.push(undo);

        const add: IDataActionToolbar = {
            action: addNewDraftWorks,
            component: DRAFT_WORKS_MAINTENANCE_TOOLBAR,
            method: ADD_METHOD_TOOLBAR,
            name: fields.find(p => p.name === ADD_NEW_DRAFT_WORK_STATE_KEY).data,
            icon: 'icon ms-Icon ms-Icon--CircleAddition'
        }
        actionList.push(add);

        

        return actionList;
    }

    render() {
        const {
            changesMade,
            showYesNoPrompt,
            hideModal,
            resetMessageBanner,
            scroll,
            toolbarWidth,
            saveResultData,
            activeTab,
            tabs,
            toolbarData,
            work,
            lookupValues,
            customer,
        } = this.props;

        const isReadonly: boolean = tabs[activeTab].isReadonly;
        let { dataAction } = { ...this.state };
        if (tabs[activeTab].registeredWorkMaintenanceState != undefined) {
            tabs[activeTab].registeredWorkMaintenanceState.isNew = true;
        }
        let isNew = (tabs[activeTab].draftWorkMaintenanceState || tabs[activeTab].registeredWorkMaintenanceState).isNew;
        const hasPermission = MembersPortalService.hasPermissionForMenu("registerNewWork", MembersPortalRoles.FullAccess);
        return (
            <div className={isReadonly && !changesMade ? 'versionHistoryPointer' : ''}>
                <ToolbarComponent
                    changesMade={changesMade}
                    showYesNoPrompt={showYesNoPrompt}
                    hideModal={hideModal}
                    resetMessageBanner={this.resetMessageBanner.bind(this)}
                    scroll={scroll}
                    toolbarWidth={toolbarWidth}
                    saveResultData={saveResultData}
                    activeTab={activeTab}
                    tabs={tabs}
                    dataActionToolbar={this.state.dataAction}
                    toolbarData={toolbarData}
                    component={DRAFT_WORKS_MAINTENANCE_TOOLBAR}
                    isNew={isNew}
                    isReadonly={isReadonly}
                    work={work}
                    lookupValues={lookupValues}
                    customer={customer}
                    hasPermission={hasPermission}
                />
            </div>
        );
    }
}

export default DraftWorksMaintenanceToolbar;
